export interface IDateRange {
	from: Date;
	to: Date;
}

export interface IDateRangeExtended extends IDateRange {
	rangeType: DateRangeType;
}

export interface IDate {
	date: Date;
	isRelative?: boolean;
}

export interface IKenodDateRange {
	start: Date;
	end: Date;
}

export enum DateRangeType {
	Fixed,
	Relative,
	TimeWindow
}
